import { render, staticRenderFns } from "./ManagerArrivals.vue?vue&type=template&id=93e40c84&scoped=true&"
import script from "./ManagerArrivals.vue?vue&type=script&lang=js&"
export * from "./ManagerArrivals.vue?vue&type=script&lang=js&"
import style0 from "./ManagerArrivals.vue?vue&type=style&index=0&id=93e40c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e40c84",
  null
  
)

export default component.exports